/** @format */

"use client";

import { styled } from "@mui/system";
import React, { Suspense } from "react";
import type { Props as ApexChartProps } from "react-apexcharts";

const ApexChart = React.lazy(() => import("react-apexcharts"));

const StyledApexChart = styled(ApexChart)``;

export const Chart = (props: ApexChartProps) => (
	<Suspense fallback={<div style={{ height: props.height || 350 }} />}>
		<StyledApexChart {...props} />
	</Suspense>
);
